import classNames from "classnames";
import React from "react";
import "./PopupSection.scss";

export function PopupSection({ children, className = "" }) {
  return (
    <div className={classNames(["popup__section", className])}>{children}</div>
  );
}
